/* ============================================================
   PATEX — theme JS
   Shopify Cart AJAX API 기반. 프로토타입의 인터랙션을 이식.
   ============================================================ */
(function () {
  'use strict';

  var R = (window.PATEX && window.PATEX.routes) || {};
  var S = (window.PATEX && window.PATEX.strings) || {};

  /* ---------- Toast ---------- */
  var toastTimer = null;
  function toast(msg) {
    var t = document.getElementById('toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('show'); }, 2800);
  }
  window.patexToast = toast;

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    return '₩' + (cents / 100).toLocaleString('ko-KR', { maximumFractionDigits: 0 });
  }

  /* ---------- 모바일 메뉴 ---------- */
  function groups() { return document.querySelectorAll('.nav .group'); }
  window.toggleMenu = function () {
    document.body.classList.toggle('menu-open');
  };
  function closeMenu() {
    if (!document.body.classList.contains('menu-open')) return;
    document.body.classList.remove('menu-open');
  }
  /* 데스크톱 사이드바 그룹 토글 / 모바일 아코디언 공용 */
  window.toggleGroup = function (head) {
    head.parentElement.classList.toggle('open');
  };

  /* ---------- 아코디언 (상세 정보) — 한 번에 하나만 ---------- */
  window.toggleAcc = function (head) {
    var item = head.parentElement;
    var wasOpen = item.classList.contains('open');
    item.parentElement.querySelectorAll('.acc-item').forEach(function (it) {
      it.classList.remove('open');
      var pm = it.querySelector('.pm');
      if (pm) pm.textContent = '+';
    });
    if (!wasOpen) {
      item.classList.add('open');
      var pm = head.querySelector('.pm');
      if (pm) pm.textContent = '−';
    }
  };
  /* 제목으로 특정 아코디언 열기 (SIZE CHART 등) — 스크롤 이동 없음 */
  window.openAcc = function (title) {
    var items = document.querySelectorAll('.pd-info .acc-item');
    for (var i = 0; i < items.length; i++) {
      var label = items[i].querySelector('.acc-head span');
      if (label && label.textContent.trim().toUpperCase() === title.toUpperCase()) {
        if (!items[i].classList.contains('open')) items[i].querySelector('.acc-head').click();
        return;
      }
    }
  };

  /* ---------- Cart drawer ---------- */
  var drawer = function () { return document.getElementById('cdrawer'); };

  function renderDrawer(cart) {
    var box = document.getElementById('cdItems');
    if (!box) return;
    if (!cart.item_count) {
      box.innerHTML = '<div class="cd-empty">' + (S.cartEmpty || '장바구니가 비어 있습니다.') + '</div>';
    } else {
      box.innerHTML = cart.items.map(function (i, idx) {
        var img = i.image ? i.image.replace(/(\.[^.]*)$/, '_200x$1') : '';
        var opts = (i.options_with_values || [])
          .filter(function (o) { return o.value && o.value !== 'Default Title'; })
          .map(function (o) { return o.name + ' ' + o.value; }).join(' / ');
        return '' +
          '<div class="cd-item">' +
            (img ? '<img class="cd-th" src="' + img + '" alt="">' : '<span class="cd-th"></span>') +
            '<div>' +
              '<div class="cd-row">' +
                '<span class="cd-nm">' + i.product_title + '</span>' +
                '<span class="cd-pr">' + formatMoney(i.line_price) + '</span>' +
              '</div>' +
              (opts ? '<div class="cd-sub">' + opts + '</div>' : '') +
              '<div class="cd-ctl">' +
                '<span class="cd-qty">' +
                  '<button type="button" data-line="' + (idx + 1) + '" data-qty="' + (i.quantity - 1) + '">−</button>' +
                  i.quantity +
                  '<button type="button" data-line="' + (idx + 1) + '" data-qty="' + (i.quantity + 1) + '">+</button>' +
                '</span>' +
                '<button type="button" class="cd-rm" data-line="' + (idx + 1) + '" data-qty="0">Remove</button>' +
              '</div>' +
            '</div>' +
          '</div>';
      }).join('');
    }
    var sub = document.getElementById('cdSubtotal');
    if (sub) sub.textContent = formatMoney(cart.total_price);
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = 'Cart (' + cart.item_count + ')';
    });
  }

  function fetchCart() {
    return fetch(R.cart + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function changeLine(line, qty) {
    return fetch(R.cart_change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      renderDrawer(cart);
      return cart;
    });
  }

  window.openDrawer = function () {
    fetchCart().then(function (cart) {
      renderDrawer(cart);
      drawer().classList.add('open');
    });
  };
  window.closeDrawer = function () {
    var d = drawer();
    if (d) d.classList.remove('open');
  };

  /* ---------- 검색 오버레이 + 실시간 추천 (suggest.json) ---------- */
  var sovTimer = null;
  var sovCtl = null; /* 이전 요청 취소용 — 늦게 도착한 응답이 최신 결과를 덮지 않게 */
  function sov() { return document.getElementById('sov'); }

  window.openSearch = function () {
    var el = sov();
    if (!el) return;
    window.closeDrawer();
    el.classList.add('open');
    var input = document.getElementById('sovInput');
    if (input) setTimeout(function () { input.focus(); }, 50);
  };
  window.closeSearch = function () {
    var el = sov();
    if (el) el.classList.remove('open');
  };
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') window.closeSearch();
  });

  /* 전체 검색(/search)은 추천과 달리 접두어 매칭을 하지 않는다.
     마지막 단어에 * 를 붙여야 "SLAS" 로도 "Slashed…" 가 잡힌다. */
  function wildcard(q) {
    q = q.trim();
    if (!q) return q;
    var last = q.charAt(q.length - 1);
    if (last === '*' || last === '"') return q;
    return q + '*';
  }

  function escHtml(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* 검색 결과 섹션(main-search)이 그려준 .gcell 들을 오버레이 행으로 변환.
     추천 전용 API(suggest.json)는 한국어 스토어에서 접두어 매칭을 하지 않아
     결과 페이지와 답이 달라진다 — 같은 엔진(전체 검색 + 와일드카드)을 쓰면
     추천과 Enter 결과가 항상 일치한다. */
  function renderSuggest(q, cells) {
    var box = document.getElementById('sovRes');
    if (!box) return;
    if (!cells.length) {
      box.innerHTML = '<div class="sov-note">' + (S.searchEmpty || 'No results') + '</div>';
      return;
    }
    var html = cells.map(function (c) {
      var img = c.querySelector('.gimg img');
      var nameEl = c.querySelector('.gname');
      var priceEl = c.querySelector('.gprice');
      var out = (c.className || '').indexOf('soldout') !== -1;
      var thumb = img ? '<img src="' + escHtml(img.getAttribute('src')) + '" alt="" loading="lazy">' : '<span></span>';
      var inner = thumb + '<span><span class="nm">' + escHtml(nameEl ? nameEl.textContent.trim() : '') +
        '</span><span class="pr">' + escHtml(priceEl ? priceEl.textContent.trim() : '') + '</span></span>';
      /* 품절은 상세로 안 보내는 사이트 규칙 유지 — 링크 없이 표시만 */
      return out
        ? '<span class="sov-item soldout">' + inner + '</span>'
        : '<a class="sov-item" href="' + escHtml(c.getAttribute('href') || '#') + '">' + inner + '</a>';
    }).join('');
    html += '<a class="sov-all" href="' + (R.search || '/search') + '?q=' + encodeURIComponent(wildcard(q)) + '&type=product">' +
      (S.searchAll || 'View all results') + ' →</a>';
    box.innerHTML = html;
  }

  /* Enter 제출 시에도 와일드카드를 붙여 접두어 검색이 되게 한다 */
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('#sov form');
    if (!f) return;
    var input = f.querySelector('#sovInput');
    if (input) input.value = wildcard(input.value);
  });

  document.addEventListener('input', function (e) {
    if (e.target.id !== 'sovInput') return;
    var q = e.target.value.trim();
    clearTimeout(sovTimer);
    if (sovCtl) sovCtl.abort();
    var box = document.getElementById('sovRes');
    if (!q) { if (box) box.innerHTML = ''; return; }
    sovTimer = setTimeout(function () {
      sovCtl = new AbortController();
      /* Section Rendering API: 검색 결과 페이지의 main-search 섹션만 HTML 로 받아 파싱.
         Enter 로 가는 /search 와 완전히 같은 엔진·같은 와일드카드를 태운다. */
      fetch((R.search || '/search') +
            '?q=' + encodeURIComponent(wildcard(q)) +
            '&type=product&section_id=main-search',
            { signal: sovCtl.signal })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.text();
        })
        .then(function (htmlText) {
          var doc = new DOMParser().parseFromString(htmlText, 'text/html');
          var cells = [].slice.call(doc.querySelectorAll('.gcell')).slice(0, 8);
          renderSuggest(q, cells);
        })
        .catch(function (err) {
          /* 조용히 비우면 "아무것도 안 뜸"과 구분이 안 된다 — 실패는 실패라고 보여준다 */
          if (err.name !== 'AbortError' && box) {
            box.innerHTML = '<div class="sov-note">' + (S.searchError || '검색에 실패했습니다 — 잠시 후 다시 시도해 주세요') + '</div>';
          }
        });
    }, 250);
  });

  /* 드로어 내부 클릭은 절대 닫히지 않게 — composedPath로 클릭 시점 경로 판정 */
  document.addEventListener('click', function (e) {
    var d = drawer();
    if (!d || !d.classList.contains('open')) return;
    var path = e.composedPath();
    var insideDrawer = path.indexOf(d) !== -1;
    var onCartBtn = path.some(function (el) { return el && el.hasAttribute && el.hasAttribute('data-cart-open'); });
    if (!insideDrawer && !onCartBtn) window.closeDrawer();
  });

  /* 드로어 수량/삭제 (이벤트 위임 — 재렌더링돼도 동작) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('#cdItems [data-line]');
    if (!btn) return;
    changeLine(parseInt(btn.dataset.line, 10), parseInt(btn.dataset.qty, 10));
  });

  /* 카트 메모 */
  document.addEventListener('change', function (e) {
    if (e.target.id !== 'cdNote') return;
    fetch(R.cart_update, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: e.target.value })
    });
  });

  /* ---------- ADD TO CART: 썸네일이 상단 CART로 날아감 ---------- */
  function flyToCart() {
    var srcImg = document.querySelector('.pd-images img');
    var target = document.querySelector('[data-cart-open]');
    if (!srcImg || !target || !srcImg.complete) return 0;
    var a = srcImg.getBoundingClientRect();
    var b = target.getBoundingClientRect();
    if (!a.width) return 0;
    var ghost = document.createElement('img');
    ghost.src = srcImg.currentSrc || srcImg.src;
    ghost.className = 'fly-ghost';
    ghost.style.cssText = 'left:' + a.left + 'px;top:' + a.top + 'px;width:' + a.width + 'px;height:' + a.height + 'px';
    document.body.appendChild(ghost);
    var dx = (b.left + b.width / 2) - (a.left + a.width / 2);
    var dy = (b.top + b.height / 2) - (a.top + a.height / 2);
    var anim = ghost.animate([
      { transform: 'translate(0,0) scale(1)', opacity: 1 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(' + (28 / a.width) + ')', opacity: .25 }
    ], { duration: 700, easing: 'cubic-bezier(.5,-0.1,.3,1)' });
    anim.onfinish = function () { ghost.remove(); };
    return 750;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var id = form.querySelector('[name="id"]');
    if (!id || !id.value) { toast(S.selectSize || '사이즈를 선택해 주세요'); return; }
    var delay = flyToCart();
    fetch(R.cart_add, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(id.value, 10), quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { toast(res.description || res.message); return; }
        setTimeout(function () { window.openDrawer(); }, delay);
      })
      .catch(function () { toast('장바구니 담기에 실패했습니다'); });
  });

  /* ---------- Hero: 이미지 1장씩 + 톤에 따른 화이트/블랙 자동 전환 ---------- */
  function initHero() {
    var hero = document.querySelector('[data-hero]');
    if (!hero) return;
    var slides = hero.querySelectorAll('.slide');
    if (!slides.length) return;
    var idx = 0;
    var interval = parseInt(hero.dataset.interval, 10) || 5200;

    function apply() {
      slides.forEach(function (s, i) { s.classList.toggle('show', i === idx); });
      document.body.classList.toggle('hero-dark', slides[idx].dataset.tone === 'white');
    }
    apply();
    if (slides.length > 1) {
      setInterval(function () { idx = (idx + 1) % slides.length; apply(); }, interval);
    }
  }

  /* ---------- 룩북 가로 스크롤 (데스크톱) ---------- */
  function initLookbook() {
    var el = document.querySelector('[data-lb-scroll]');
    if (!el) return;
    el.addEventListener('wheel', function (e) {
      if (window.innerWidth <= 1080) return;
      if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) { e.preventDefault(); el.scrollLeft += e.deltaY; }
    }, { passive: false });
    var dragging = false, x0 = 0, s0 = 0;
    el.addEventListener('pointerdown', function (e) { dragging = true; x0 = e.clientX; s0 = el.scrollLeft; });
    window.addEventListener('pointermove', function (e) { if (dragging) el.scrollLeft = s0 - (e.clientX - x0); });
    window.addEventListener('pointerup', function () { dragging = false; });
    window.addEventListener('keydown', function (e) {
      if (window.innerWidth <= 1080) return;
      var step = Math.round(window.innerWidth * 0.7);
      if (e.key === 'ArrowLeft') el.scrollBy({ left: -step, behavior: 'smooth' });
      if (e.key === 'ArrowRight') el.scrollBy({ left: step, behavior: 'smooth' });
    });
  }

  /* ---------- 홈: 배너 아래로 스크롤하면 타이포를 블랙으로 ----------
     흰 푸터 위에서 hero-dark(화이트 타이포)가 유지되면 글자가 안 보인다.
     scroll 이벤트 대신 IntersectionObserver — 스크롤 컨테이너가
     데스크톱(.main)/모바일(문서)로 달라도 뷰포트 기준으로 동일하게 동작한다. */
  function initHeroScroll() {
    var hero = document.querySelector('.hero');
    if (!hero) return;
    var nav = document.querySelector('.sidebar .nav');
    function onScroll() {
      /* 판정선 = 사이드바 메뉴 하단 + 여유. 배너 하단이 이 선 위로 올라오면
         (= 흰 푸터가 메뉴 영역까지 올라오면) 타이포를 블랙으로 전환한다.
         고정값이면 낮은 화면에서 메뉴가 흰 배경 위에 흰 글자로 남는다. */
      var line = 140;
      if (nav && getComputedStyle(nav).display !== 'none') {
        var nb = nav.getBoundingClientRect().bottom + 20;
        if (nb > line) line = nb;
      }
      document.body.classList.toggle('hero-scrolled', hero.getBoundingClientRect().bottom < line);
    }
    /* 데스크톱은 .main 이, 모바일은 문서가 스크롤된다 — 둘 다 감시 */
    var main = document.querySelector('.main');
    if (main) main.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
  }

  /* ---------- 상세 이미지 갤러리(라이트박스) ---------- */
  function plb() { return document.getElementById('plb'); }
  window.plbSet = function (i) {
    var el = plb();
    if (!el) return;
    var thumbs = el.querySelectorAll('.plb-th');
    if (!thumbs.length) return;
    i = Math.max(0, Math.min(thumbs.length - 1, i));
    var img = document.getElementById('plbImg');
    img.src = thumbs[i].dataset.large;
    thumbs.forEach(function (t, k) { t.classList.toggle('on', k === i); });
    el.dataset.i = i;
    thumbs[i].scrollIntoView({ block: 'nearest' });
  };
  window.openLightbox = function (i) {
    var el = plb();
    if (!el) return;
    window.plbSet(i || 0);
    el.classList.add('open');
    document.body.classList.add('plb-open');
  };
  window.closeLightbox = function () {
    var el = plb();
    if (el) el.classList.remove('open');
    document.body.classList.remove('plb-open');
  };
  document.addEventListener('keydown', function (e) {
    var el = plb();
    if (!el || !el.classList.contains('open')) return;
    var i = parseInt(el.dataset.i || '0', 10);
    if (e.key === 'Escape') window.closeLightbox();
    else if (e.key === 'ArrowDown' || e.key === 'ArrowRight') window.plbSet(i + 1);
    else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') window.plbSet(i - 1);
  });

  /* ---------- 룩북: 이미지 밝기에 따른 메뉴 글자색 자동 전환 ----------
     풀블리드 이미지 위에서는 검정 메뉴가 안 보이는 구간이 생긴다. 홈 배너처럼 이미지마다
     손으로 흰/검을 정하는 대신, 화면에 보이는 이미지에서 "메뉴가 겹치는 영역"과 "유틸바가
     겹치는 영역"의 평균 밝기를 읽어 각각 따로 전환한다(왼쪽은 밝고 오른쪽은 어두운 사진이 흔하다).
     - 분석은 240px 축소본(data-lb-src)을 캔버스에 1회 그려 픽셀을 캐시, 스크롤 시엔 영역 평균만 계산
     - 히스테리시스: 어두우면(<0.50) 흰 글자, 밝으면(>0.58) 검정, 그 사이는 이전 값 유지 → 깜빡임 방지
     - 모바일(<=1080)은 흰 헤더바라 항상 검정
     - 이미지는 같은 도메인(/cdn/)에서 오므로 캔버스 오염 문제 없음. crossOrigin 은 보험. */
  function initLookbookTone() {
    var wrap = document.querySelector('.lb-wrap[data-lb-tone]');
    if (!wrap) return;
    var mode = wrap.dataset.lbTone || 'auto';
    function setTone(nav, util) {
      document.body.classList.toggle('tone-nav-light', !!nav);
      document.body.classList.toggle('tone-util-light', !!util);
    }
    if (mode === 'white') { setTone(true, true); return; }
    if (mode === 'black') { setTone(false, false); return; }

    var scroller = wrap.querySelector('[data-lb-scroll]');
    var imgs = [].slice.call(wrap.querySelectorAll('.lb-img'));
    if (!scroller || !imgs.length) return;

    var W = 160;           /* 분석 캔버스 폭(px). 높이는 원본 비율 유지. 48이면 유틸바 영역이 픽셀 10여 개뿐이라 판정이 흔들린다 */
    var samples = [];      /* i → { w, h, data } */

    imgs.forEach(function (img, i) {
      var probe = new Image();
      probe.crossOrigin = 'anonymous';
      probe.onload = function () {
        var h = Math.max(8, Math.round(W * probe.naturalHeight / probe.naturalWidth));
        var c = document.createElement('canvas');
        c.width = W; c.height = h;
        var ctx = c.getContext('2d', { willReadFrequently: true });
        ctx.drawImage(probe, 0, 0, W, h);
        try { samples[i] = { w: W, h: h, data: ctx.getImageData(0, 0, W, h).data }; }
        catch (e) { samples[i] = null; }
        now();
      };
      probe.src = img.dataset.lbSrc || img.currentSrc || img.src;
    });

    /* 축소본에서 비율 좌표(0..1) 사각형의 "어두운 픽셀 비율"(상대휘도 < 0.45).
       평균 밝기는 나무/하늘처럼 아주 어둡고 아주 밝은 픽셀이 반반인 사진에서 0.5 근처로 뭉개져
       판정이 안 된다. 검정 글자는 어두운 픽셀 위에서 사라지므로, 그 비율로 본다. */
    function darkAt(s, fx0, fy0, fx1, fy1) {
      var x0 = Math.max(0, Math.floor(fx0 * s.w)), x1 = Math.min(s.w, Math.ceil(fx1 * s.w));
      var y0 = Math.max(0, Math.floor(fy0 * s.h)), y1 = Math.min(s.h, Math.ceil(fy1 * s.h));
      var dark = 0, n = 0, d = s.data;
      for (var y = y0; y < y1; y++) {
        for (var x = x0; x < x1; x++) {
          var k = (y * s.w + x) * 4;
          if ((0.2126 * d[k] + 0.7152 * d[k + 1] + 0.0722 * d[k + 2]) / 255 < 0.45) dark++;
          n++;
        }
      }
      return n ? { dark: dark, n: n } : null;
    }

    /* 뷰포트 px 사각형이 걸치는 이미지들 전체의 어두운 픽셀 비율. 이미지가 없으면 null */
    function regionDark(rect) {
      var dark = 0, n = 0;
      imgs.forEach(function (img, i) {
        var s = samples[i]; if (!s) return;
        /* 지연 로딩으로 아직 안 그려진 이미지는 화면에선 흰 바탕이다 — 판정에서 뺀다 */
        if (!img.complete || !img.naturalWidth) return;
        var r = img.getBoundingClientRect();
        if (!r.width || !r.height) return;
        var ix0 = Math.max(rect.left, r.left), ix1 = Math.min(rect.right, r.right);
        var iy0 = Math.max(rect.top, r.top), iy1 = Math.min(rect.bottom, r.bottom);
        if (ix1 <= ix0 || iy1 <= iy0) return;
        var o = darkAt(s, (ix0 - r.left) / r.width, (iy0 - r.top) / r.height, (ix1 - r.left) / r.width, (iy1 - r.top) / r.height);
        if (!o) return;
        dark += o.dark; n += o.n;
      });
      return n ? dark / n : null;
    }

    var navLight = null, utilLight = null;
    function decide(ratio, prev) {
      if (ratio === null) return false;          /* 그 자리에 보이는 이미지가 없음 = 흰 바탕 → 검정 */
      if (prev === null) return ratio >= 0.35;
      return ratio >= 0.40 ? true : (ratio <= 0.30 ? false : prev);
    }
    function compute() {
      if (window.innerWidth <= 1080) { setTone(false, false); return; }
      var logo = document.querySelector('.sidebar .logo');
      var nav = document.querySelector('.sidebar .nav');
      var util = document.querySelector('.utilbar');
      var lr = logo && logo.getBoundingClientRect(), nr = nav && nav.getBoundingClientRect(), ur = util && util.getBoundingClientRect();
      var navRect = {
        left: 0,
        top: lr ? lr.top : 0,
        right: Math.max(nr ? nr.right : 0, lr ? lr.right : 0) + 24,
        bottom: nr ? nr.bottom : (lr ? lr.bottom : 0)
      };
      var utilRect = ur ? { left: ur.left - 24, top: ur.top - 14, right: ur.right + 24, bottom: ur.bottom + 14 } : null;
      var dn = regionDark(navRect), du = utilRect ? regionDark(utilRect) : null;
      /* 어두운 비율 40% 이상 → 흰 글자, 30% 이하 → 검정. 그 사이는 이전 값 유지(깜빡임 방지).
         첫 판정(null)은 유지할 값이 없으므로 35% 한 줄로 바로 정한다. */
      navLight  = decide(dn, navLight);
      utilLight = decide(du, utilLight);
      setTone(navLight, utilLight);
    }
    /* 스크롤은 rAF 로 프레임당 1회로 묶고, 이미지 로드·초기 판정은 즉시 계산한다.
       rAF 는 백그라운드 탭에서 멈추므로 여기에만 의존하면 탭을 열어둔 채 돌아왔을 때
       첫 판정이 늦게 반영된다. */
    var raf = null;
    function schedule() {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = null; compute(); });
    }
    function now() { raf = null; compute(); }
    scroller.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    imgs.forEach(function (img) { img.addEventListener('load', now); });
    document.addEventListener('visibilitychange', function () { if (!document.hidden) now(); });
    now();
  }

  /* ---------- Client Service (카테고리 탭 + 아코디언) ---------- */
  /* 이 페이지 본문은 Shopify 페이지 편집기에 붙여넣는 HTML 이라 onclick 을 넣을 수 없다
     (편집기가 인라인 핸들러를 제거한다). 그래서 마크업은 순수 HTML 로 두고
     동작은 여기서 클래스 선택자로 붙인다.
     body.cs-js 는 JS 가 살아있을 때만 붙으며, CSS 의 접힘 규칙 전체가 이 클래스에
     묶여 있다. JS 가 실패하면 모든 카테고리와 본문이 그냥 펼쳐진 상태로 보인다. */
  function initClientService() {
    var cats = document.querySelectorAll('.cs-cat');
    if (!cats.length) return;
    document.body.classList.add('cs-js');

    var links = document.querySelectorAll('.cs-nav a');

    function show(id) {
      var hit = false;
      cats.forEach(function (s) {
        var on = s.id === id;
        if (on) hit = true;
        s.classList.toggle('on', on);
      });
      links.forEach(function (a) {
        a.classList.toggle('active', a.getAttribute('href') === '#' + id);
      });
      return hit;
    }

    links.forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = (a.getAttribute('href') || '').replace('#', '');
        if (!id) return;
        e.preventDefault();
        show(id);
        history.replaceState(null, '', '#' + id);
        var main = document.querySelector('.main');
        if (main) main.scrollTop = 0;
        window.scrollTo(0, 0);
      });
    });

    /* 아코디언: 제목(h4)이 토글. 키보드로도 열 수 있어야 한다. */
    document.querySelectorAll('.cs-item > h4').forEach(function (h) {
      h.setAttribute('role', 'button');
      h.setAttribute('tabindex', '0');
      h.setAttribute('aria-expanded', 'false');
      function toggle() {
        var open = h.parentElement.classList.toggle('open');
        h.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      h.addEventListener('click', toggle);
      h.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
      });
    });

    /* 주소창의 #해시가 가리키는 카테고리를 먼저 띄우고, 없으면 첫 카테고리. */
    if (!show((location.hash || '').replace('#', ''))) show(cats[0].id);
  }

  /* ---------- Init ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    /* 라이트박스를 body 최상위로 이동(portal).
       .main 내부에 두면 사이드바(z-40)·유틸바(z-45)가 오버레이 위층이 되어
       CLOSE 자리의 클릭을 CART 링크가 가로챈다. body 직속이면 z-80이 그대로 통한다. */
    var plbEl = document.getElementById('plb');
    if (plbEl && plbEl.parentElement !== document.body) document.body.appendChild(plbEl);

    initHero();
    initHeroScroll();
    initLookbook();
    initLookbookTone();
    initClientService();
    fetchCart().then(renderDrawer).catch(function () {});
    /* 메뉴 링크 클릭 시 모바일 메뉴 닫기 */
    document.querySelectorAll('.nav a').forEach(function (a) {
      a.addEventListener('click', closeMenu);
    });
  });
})();
